import {Breadcrumbs} from '@management-ui/core';
import {Paper} from '@mui/material';
import * as React from 'react';
import routes from '../../../../routes';
import Table from './Table';

export default function DateRequests() {
  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Orders', link: routes.orders.index}, {title: 'Date Requests'}]}/>
      <Paper>
        <Table/>
      </Paper>
    </div>
  );
}
